import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { AssetsManagementService } from '../../services/assets-management.service';
import { AssetsManagementModel, MainAssetModel, SubTypeModel, TransferUserModel } from '../assets-management.model';
import { CommonMessageService } from '../../services/common-message.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import * as moment from 'moment';

@Component({
  selector: 'app-hardware-assets',
  templateUrl: './hardware-assets.component.html',
  styleUrls: ['./hardware-assets.component.css']
})
export class HardwareAssetsComponent implements OnInit {
  assetsManagementModel: AssetsManagementModel;
  mainAssetModel: MainAssetModel;
  transferUserModel: TransferUserModel;
  hardwareTypeAssetsList;
  selectedHardwareStatus;
  selectBranch;
  softwareStatus;
  hideSaveButton: boolean;
  userRole;
  showAddSoftwareButton: boolean;
  showExcelExportButton: boolean;
  serialTagList = [];
  searchSerialTagNumber;
  branchList;
  currentDate;
  formatCurrentDate;
  previousMonthCurrentDate;
  twoMonthbeforeCurrentDate;
  menuList: any;
  allowedComponents = new Set<string>();

  // search = (text$: Observable<string>) => {
  //   return text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged(),
  //     map(term => term.length < 2 ? []
  //       : this.getSerialTagNumberList(term)),
  //     debounceTime(2000),
  //     map(term => this.serialTagList.filter(serviceTag => new RegExp(term, 'mi').test(serviceTag.name)).slice(0, 10))
  //   )
  // }

  // inputFormatter(value: any) {
  //   console.log('input value', value);
  //   return value.serviceTagNumber;
  // }

  // getSerialTagNumberList(text: any): any {
  //   console.log('text value', text);
  //   if (text != "") {
  //     this.assetsManagementService.serviceTagNumberList('Hardware', text).subscribe((resp: any) => {
  //       this.serialTagList = resp;
  //       console.log('serial tag list', this.serialTagList);
  //     });
  //   }

  //  /* No need of this code
  //   if (this.serialTagList.length > 0) {
  //   this.filterListByTagNumber();
  //   } */
  // }

  // searchSerialTagNumberList() {
  //   console.log('serial tag value', this.searchSerialTagNumber);
  //   this.serialTagList = [];
  //   this.getSerialTagNumberList(this.searchSerialTagNumber);
  // }

  // afterSearchSerialTagNumber(serialTagNumber) {
  //   if (serialTagNumber) {
  //     // this.hardwareAssetsList = this.newHardwareList;
  //   } else {
  //     this.getHardwareAssetsList();
  //   }
  // }

  // newHardwareList = [];
  // filterListByTagNumber() {
  //   this.serialTagList.map((res: any) => {
  //     this.hardwareAssetsList.map((res1: any) => {
  //       console.log('res & res1', res.serviceTagNumber, res1.asset.serviceTagNumber);
  //       if (res.serviceTagNumber == res1.asset.serviceTagNumber) {
  //         this.newHardwareList.push(res1);
  //       }
  //     })
  //   })
  //   this.hardwareAssetsList = this.newHardwareList;
  //   console.log('new hardware list', this.newHardwareList);
  // }

  constructor(private modalService: NgbModal,
    private assetsManagementService: AssetsManagementService,
    private commonMessageService: CommonMessageService,
    private masterDataService: MasterDataService) {
    const current = new Date();
    this.currentDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }

  ngOnInit(): void {
    console.log('current date', this.currentDate);
    var currentDate1 = new Date(this.currentDate.year + '-' + this.currentDate.month + '-' + this.currentDate.day);
    this.formatCurrentDate = moment(currentDate1).format("YYYY-MM-DD");
    var newDate = new Date(this.formatCurrentDate);
    newDate.setMonth(newDate.getMonth() - 1);
    var changeNewDate = newDate.toLocaleDateString();
    var againChangeNewDate = new Date(changeNewDate);
    this.previousMonthCurrentDate = {
      year: againChangeNewDate.getFullYear(),
      month: againChangeNewDate.getMonth() + 1,
      day: againChangeNewDate.getDate(),
    };
    console.log('this.previousMonthCurrentDate', this.previousMonthCurrentDate);

    this.twoMonthbeforeCurrentDate = {
      year: againChangeNewDate.getFullYear(),
      month: againChangeNewDate.getMonth(),
      day: againChangeNewDate.getDate()
    }
    console.log('this.twoMonthbeforeCurrentDate', this.twoMonthbeforeCurrentDate);

    // this.userRole = localStorage.getItem('userRole');
    // if (this.userRole == 'Account Executive' || this.userRole == 'HR Assistant' ||
    //   this.userRole == 'HR Executive' || this.userRole == 'HR Manager' || this.userRole == 'Partner') {
    //   this.showAddSoftwareButton = true;
    // } else {
    //   this.showAddSoftwareButton = false;
    // }
   
  this.menuList = JSON.parse(localStorage.getItem('menuList'));

  this.menuList.forEach(menu => {
    menu.menu?.submenus?.forEach(submenu => {
      this.allowedComponents.add(submenu.subMenu);
    });
  });

    // this.selectBranch = null;
    this.selectedHardwareStatus = 'all';
    this.assetsManagementModel = new AssetsManagementModel();
    this.mainAssetModel = new MainAssetModel();
    this.mainAssetModel.asset = new AssetsManagementModel();
    this.transferUserModel = new TransferUserModel();
    this.mainAssetModel.fromUser = new TransferUserModel();
    this.assetsManagementModel.subType = new SubTypeModel();
    this.showExcelExportButton = false;
    this.getBranchList();
    this.getAllTypeHardwareList();
    this.getTransferToUserList();
    this.getPendingTransferRequestList();
    this.getTransferRequestList();
    this.getServiceTagNumberList();
    console.log('asset management value', this.assetsManagementModel);
  }

  hasAccess(subMenuName: string): boolean {
  return this.allowedComponents.has(subMenuName);
}

  getBranchList() {
    this.masterDataService.getBranch().subscribe((res) => {
      console.log('branchlist', res);
      this.branchList = res;
      var branchIndex = -1;
      this.branchList.forEach((element, key) => {
        if (element.name == 'Pune') {
          branchIndex = key;
        }
      });
      this.selectBranch = this.branchList[branchIndex];
      this.getHardwareAssetsList();
    });
  }

  onBranchChange() {
    this.getHardwareAssetsList();
  }

  openTransferModal(transferModalContent) {
    console.log('this.mainAssetModel.fromUser', this.mainAssetModel.fromUser);
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(transferModalContent, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  getServiceTagNumberList() {
    this.assetsManagementService.serviceTagNumberList('Hardware').subscribe((resp: any) => {
      this.serialTagList = resp;
      console.log('serial tag list at transfer time', this.serialTagList);
    });
  }

  openModal(modalContent) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'xl',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(modalContent, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  closeModal() {
    this.hideSaveButton = false;
    this.showDateOfSale = false;
    this.showBlock = false;
    this.modalService.dismissAll();
    this.getHardwareAssetsList();
    this.getPendingTransferRequestList();
    this.getTransferRequestList();
    this.getServiceTagNumberList();
    this.getAllTypeHardwareList();
    this.assetsManagementModel = new AssetsManagementModel();
    this.mainAssetModel = new MainAssetModel();
    this.mainAssetModel.asset = new AssetsManagementModel();
    this.mainAssetModel.fromUser = new TransferUserModel();
    this.assetsManagementModel.subType = new SubTypeModel();
    this.selectedSerialTag = undefined;
  }

  myFiles = [];
  docType = [];
  fileChange(event, documentType) {
    console.log('document type', event);
    for (var i = 0; i < event.target.files.length; i++) {
      this.myFiles.push(event.target.files[i]);
      this.docType.push(documentType);
    }
    console.log('this.myFiles', this.myFiles);
    console.log('doctype value', this.docType);
  }

  onAddHardwareAssets() {
    console.log('myfiles', this.myFiles);
    console.log('this.assetsManagementModel', this.assetsManagementModel);
    if (this.assetsManagementModel.subType.name == 'Laptop' || this.assetsManagementModel.subType.name == 'Desktop') {
      if (this.assetsManagementModel.serviceTagNumber == undefined ||
        this.assetsManagementModel.serviceTagNumber == "" ||
        this.assetsManagementModel.make == undefined ||
        this.assetsManagementModel.make == "" ||
        this.assetsManagementModel.branch == undefined ||
        // this.assetsManagementModel.serviceProvider == undefined ||
        this.assetsManagementModel.modelNo == undefined ||
        this.assetsManagementModel.modelNo == "" ||
        this.assetsManagementModel.subType == null ||
        this.assetsManagementModel.subType == undefined ||

        // this.assetsManagementModel.dateOfRetirementOfAsset == true ||
        this.assetsManagementModel.dateOfPurchase == undefined ||
        this.assetsManagementModel.pgbPurchaseAccountingVoucherNo == undefined ||
        this.assetsManagementModel.pgbPurchaseAccountingVoucherNo == "" ||
        this.assetsManagementModel.pgbPurchaseAccountingVoucherDate == undefined ||
        this.assetsManagementModel.vendorInvoiceDate == undefined ||
        this.assetsManagementModel.vendorInvoiceNo == undefined ||
        this.assetsManagementModel.personalAsset == undefined ||
        this.assetsManagementModel.penDriveBlocked == undefined ||
        this.assetsManagementModel.recoveryDiskPrepared == undefined ||
        this.assetsManagementModel.adminGuestUserPrepared == undefined ||
        this.assetsManagementModel.belarcInstalled == false ||
        this.assetsManagementModel.remoteAccessSoftwareInstalled == undefined ||
        this.assetsManagementModel.cyberoamInstalled == undefined ||
        this.assetsManagementModel.printerAccessInstalled == undefined ||
        this.assetsManagementModel.pgbTagAffixed == undefined ||
        this.assetsManagementModel.serialServiceTagAffixed == undefined
      ) {
        this.commonMessageService.swalAlertWithoutIcon('', 'Please select mandatory fields...');
        return;
      }
    } else {
      if (this.assetsManagementModel.serviceTagNumber == undefined || this.assetsManagementModel.serviceTagNumber == "" ||
        // this.assetsManagementModel.make == undefined || this.assetsManagementModel.make == "" ||
        this.assetsManagementModel.branch == undefined ||
        // this.assetsManagementModel.serviceProvider == undefined ||
        // this.assetsManagementModel.modelNo == undefined || this.assetsManagementModel.modelNo == "" ||
        this.assetsManagementModel.dateOfPurchase == undefined ||
        this.assetsManagementModel.subType == null || this.assetsManagementModel.subType == undefined ||
        this.assetsManagementModel.personalAsset == undefined ||
        this.assetsManagementModel.vendorInvoiceDate == undefined ||
        this.assetsManagementModel.vendorInvoiceNo == undefined ||
        this.assetsManagementModel.pgbPurchaseAccountingVoucherNo == undefined ||
        this.assetsManagementModel.pgbPurchaseAccountingVoucherNo == "" ||
        this.assetsManagementModel.pgbPurchaseAccountingVoucherDate == undefined
        // || this.assetsManagementModel.dateOfRetirementOfAsset == true || this.assetsManagementModel.dateOfPurchase == undefined
      ) {
        this.commonMessageService.swalAlertWithoutIcon('', 'Please select mandatory fields.');
        return;
      }
    }
    this.assetsManagementService.setAssetsManagementModel(this.assetsManagementModel);
    this.assetsManagementService.addHardwareAssetsDetails(this.myFiles, this.docType, this.hideSaveButton);
    setTimeout(() => {
      this.closeModal();
    }, 3000);
  }

  getAllTypeHardwareList() {
    this.assetsManagementService.getTypeHardwareAssets().subscribe((resp: any) => {
      this.hardwareTypeAssetsList = resp;
      console.log('hardware list', this.hardwareTypeAssetsList);
      var index = -1;
      this.hardwareTypeAssetsList.subType.forEach((element, key) => {
        if (element.name == 'Laptop') {
          index = key;
        }
      });
      this.assetsManagementModel.subType = this.hardwareTypeAssetsList.subType[index];
    });
  }

  showDateOfSale: Boolean;
  editHardwareAsset(data, modalContent) {
    console.log('edit data', data);
    if ((data.asset.block == false && (data.user == null || data.user.id == 0)) || data.user.firstName == 'Anindita') {
      this.showDateOfSale = true;
      console.log('inside if');
    } else {
      this.showDateOfSale = false;
      console.log('inside else');
    }
    console.log('Branch name', this.hardwareAssetsList);
    this.assetsManagementService.setAssetsManagementModel(data.asset);
    this.assetsManagementModel = { ...this.assetsManagementService.getAssetsManagementModel() };
    console.log('edit hardware', this.assetsManagementModel);

    const hardwareTypeIndex = this.hardwareTypeAssetsList.subType.findIndex((item) => item.id == data.asset.subType.id);
    this.assetsManagementModel.subType = this.hardwareTypeAssetsList.subType[hardwareTypeIndex];
    console.log('Edit hardware details', this.assetsManagementModel);

    const branchIndex = this.branchList.findIndex((item) => item.id == data.asset.branch.id);
    this.assetsManagementModel.branch = this.branchList[branchIndex];

    if (this.assetsManagementModel.dateOfSale != null) {
      var saleDate = new Date(this.assetsManagementModel.dateOfSale);
      console.log("salesDate", saleDate)
      var formatSaleDate = { year: saleDate.getFullYear(), month: saleDate.getMonth() + 1, day: saleDate.getDate() };
      this.assetsManagementModel.dateOfSale = formatSaleDate;
    }

    if (this.assetsManagementModel.dateOfRetirementOfAsset != null) {
      var retireDate = new Date(this.assetsManagementModel.dateOfRetirementOfAsset);
      var formatRetireDate = { year: retireDate.getFullYear(), month: retireDate.getMonth() + 1, day: retireDate.getDate() };
      this.assetsManagementModel.dateOfRetirementOfAsset = formatRetireDate;
    }

    if (this.assetsManagementModel.dateOfPurchase != null) {
      var purchaseDate = new Date(this.assetsManagementModel.dateOfPurchase);
      var formatPurchaseDate = { year: purchaseDate.getFullYear(), month: purchaseDate.getMonth() + 1, day: purchaseDate.getDate() };
      this.assetsManagementModel.dateOfPurchase = formatPurchaseDate;
    }

    if (this.assetsManagementModel.vendorInvoiceDate != null) {
      var dateOfvendorInvoice = new Date(this.assetsManagementModel.vendorInvoiceDate);
      var formatDateOfvendorInvoice = { year: dateOfvendorInvoice.getFullYear(), month: dateOfvendorInvoice.getMonth() + 1, day: dateOfvendorInvoice.getDate() };
      this.assetsManagementModel.vendorInvoiceDate = formatDateOfvendorInvoice;
    }

    if (this.assetsManagementModel.pgbPurchaseAccountingVoucherDate != null) {
      var dateOfpgbPurchaseAccountingVoucher = new Date(this.assetsManagementModel.pgbPurchaseAccountingVoucherDate);
      var formatDateOfpgbPurchaseAccountingVoucher = { year: dateOfpgbPurchaseAccountingVoucher.getFullYear(), month: dateOfpgbPurchaseAccountingVoucher.getMonth() + 1, day: dateOfpgbPurchaseAccountingVoucher.getDate() };
      this.assetsManagementModel.pgbPurchaseAccountingVoucherDate = formatDateOfpgbPurchaseAccountingVoucher;
    }

    this.hideSaveButton = true;
    this.openModal(modalContent);
  }

  blockHardwareData(data) {
    data.block = !data.block;

    // if (data.block) {
    //   this.softwareStatus = 'Blocked';
    // } else {
    //   this.softwareStatus = 'InStock';
    // }
    console.log('this.assetsManagementModel.block', data);
    this.assetsManagementService.setAssetsManagementModel(data);
    this.assetsManagementService.blockHardwareAssetsDetails(this.myFiles, this.docType);
    setTimeout(() => {
      this.getHardwareAssetsList();
      this.getServiceTagNumberList();
    }, 5000);
  }

  hardwareAssetsList;
  showBlock: Boolean;
  getHardwareAssetsList() {
    console.log('branch id', this.selectBranch, this.selectedHardwareStatus);
    this.assetsManagementService.getHardwareAssetsList(this.selectBranch.id, this.selectedHardwareStatus).subscribe((resp: any) => {
      this.hardwareAssetsList = resp;
      console.log('hardwarelist', this.hardwareAssetsList);
      this.hardwareAssetsList.map((data) => {
        if (data.user != null) {
          if (data.user.firstName == 'Anindita') {
            console.log('sowblock block if');
            this.showBlock = true;
          } else {
            this.showBlock = false;
          }
        }
      })
      if (this.selectedHardwareStatus != 'blocked') {
          this.showExcelExportButton = true;
        }else {
          console.log('inside else blocked');
          this.showExcelExportButton = false;
        }
    });
  }

  // getHardwareData(data) {
  //   if (data.user != null) {
  //     if (data.user.firstName == 'Anindita') {
  //       console.log('sowblock block if');
  //       // this.showBlock = true;
  //       return true;
  //     } else {
  //       // this.showBlock = false;
  //       return false;
  //     }
  //   }
  // }

  // getHardwareDataFoBlock(data) {
  //   if (data.user != null) {
  //     data.user.droles.map((res: any) => {
  //       if (res.name == 'HR Manager' || res.name == 'HR Executive' || res.name == 'HR Assistant') {
  //         // this.showBlock = true;
  //         return true;
  //       } else {
  //         // this.showBlock = false;
  //         return false;
  //       }
  //     })

  //   }
  // }

  getPersonalOrPGB(data) {
    var name;
    if (data.asset.personalAsset == true) {
      name = 'Personal';
    } else {
      name = 'PGB';
    }
    return name;
  }

  getHardwareStatus(data) {
    var status;
    if (data.asset.block == true) {
      status = 'Blocked';
    }
    // else if (data.asset.block == false && data.asset.release == true && data.asset.retired == false) {
    //   status = 'Released';
    // } 
    else if (data.asset.block == false && data.asset.retired == true && data.asset.dateOfRetirementOfAsset <= this.formatCurrentDate) {
      status = 'Retired';
    } else if (data.user != null && data.user.id != 0) {
      // && data.user.firstName != 'Anindita'
      status = 'Assigned';
    } else {
      status = 'Instock';
    }
    return status;
  }

  //Transfer 
  // serviceTagData = [];
  // getServiceTagnumberList(event) {
  //   console.log('event value', event);
  //   this.assetsManagementService.serviceTagNumberList('Hardware', event).subscribe((resp: any) => {
  //     this.serviceTagData = resp;
  //     console.log('service tag number list', this.serviceTagData);
  //   });
  // }

  userList;
  getTransferToUserList() {
    this.assetsManagementService.transferToUserList().subscribe((resp: any) => {
      this.userList = resp;
      console.log('transfer to list', this.userList);
    })
  }

  selectedSerialTag;
  setFromUserValue() {
    console.log('selectedValue', this.selectedSerialTag);
    this.mainAssetModel.fromUser = undefined;
    if (this.selectedSerialTag != null) {
      this.mainAssetModel.asset.id = this.selectedSerialTag.id;
      this.mainAssetModel.asset.serviceTagNumber = this.selectedSerialTag.serviceTagNumber;
      if (this.selectedSerialTag.user == null) {
        console.log('this.mainAssetModel.fromUser.firstName', this.mainAssetModel.fromUser);
        // this.mainAssetModel.fromUser.firstName = 'InStock';
        // this.mainAssetModel.fromUser.middleName = '';
        // this.mainAssetModel.fromUser.lastName = '';
      } else {
        this.mainAssetModel.fromUser = this.selectedSerialTag.user
        console.log('from user value', this.mainAssetModel.fromUser.firstName);
      }
    } else {
      this.mainAssetModel.fromUser = undefined;
    }
  }


  excuteTransferDetails() {
    console.log('transfer model', this.mainAssetModel);
    // console.log('in execute tafter his.mainAssetModel.fromUser', this.selectedSerialTag.serviceTagNumber);
    if (
      this.mainAssetModel.asset.serviceTagNumber == null ||
      // this.mainAssetModel.fromUser == null ||
      this.mainAssetModel.requsetDate == null || this.mainAssetModel.toUser == null
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', "Please Select Mandatory fields.");
    } else {
      var selectedRequestDate1 = new Date(this.mainAssetModel.requsetDate.year + '-' + this.mainAssetModel.requsetDate.month + '-' + this.mainAssetModel.requsetDate.day);
      var selectedRequestDate2 = moment(selectedRequestDate1).format("YYYY-MM-DD");
      this.mainAssetModel.requsetDate = selectedRequestDate2;

      if (this.mainAssetModel.toUser.firstName == 'In Stock') {
        this.mainAssetModel.toUser = null;
      }
      console.log('transfer model', this.mainAssetModel);
      this.assetsManagementService.setMainAssetModel(this.mainAssetModel);
      this.assetsManagementService.executeHardwareTransfer();
      setTimeout(() => {
        this.closeModal();
      }, 5000);
    }
  }

  transferRequestList = [];
  getTransferRequestList() {
    this.assetsManagementService.getHardwareTransferRequest().subscribe((resp: any) => {
      this.transferRequestList = resp;
      console.log('transfer request', this.transferRequestList);
    });
  }

  pendingTransferRequest = [];
  getPendingTransferRequestList() {
    this.assetsManagementService.getHardwarePendingRequest().subscribe((resp: any) => {
      this.pendingTransferRequest = resp;
      console.log('pending transfer request', this.pendingTransferRequest);
    });
  }

  reason;
  approveTransferRequest(data) {
    console.log('tranferData', data);
    this.assetsManagementService.approveTransferRequest(data.id, 'Approved', this.reason).subscribe((resp: any) => {
      this.commonMessageService.swalAlertWithIcon('', 'Accepted Successfully!', 'success');
      this.closeModal();
    });
  }

  // serialTagNumber;
  // checkSerialTagNumber() {
  //   console.log('serial tag value', this.serialTagList.length);
  //   if (this.serialTagList.length == 0) {
  //     console.log('inside if')
  //      this.commonMessageService.swalAlertWithoutIcon('','Can not select Blocked, Retired & Assigned assets');
  //     this.serialTagNumber = undefined;
  //     this.mainAssetModel.fromUser = undefined;
  //   }
  // }

  viewHardwareAssetDetails;
  viewHardwareAssets(hardwareDetails, modalContent) {
    console.log('view siftware details', hardwareDetails);
    this.viewHardwareAssetDetails = hardwareDetails;
    this.openTransferModal(modalContent);
  }

  resendTransferRequest(data) {
    console.log('resend request', data);
    this.mainAssetModel = data;
    console.log('main assetmodal request', this.mainAssetModel);

    this.assetsManagementService.setMainAssetModel(this.mainAssetModel);
    this.assetsManagementService.executeHardwareTransfer();
    setTimeout(() => {
      this.getPendingTransferRequestList();
    }, 10000);
  }

  getPartnerName(data) {
    console.log('partner data', data);
    var partnerName;
    if (data.user != null) {
      if (data.user.userOfficialDetails.reportingPartners != null) {
        if (data.user.userOfficialDetails.reportingPartners.length > 0) {
          partnerName = data.user.userOfficialDetails.reportingPartners[data.user.userOfficialDetails.reportingPartners.length - 1].reportingPartner.firstName
            // +' '+data.user.userOfficialDetails.reportingPartners[data.user.userOfficialDetails.reportingPartners.length-1].reportingPartner.middleName
            + ' ' + data.user.userOfficialDetails.reportingPartners[data.user.userOfficialDetails.reportingPartners.length - 1].reportingPartner.lastName;
          return partnerName;
        } else {
          return 'NA';
        }
      } else {
        return 'NA';
      }
    } else {
      return 'NA';
    }
  }

  exportToExcelClick() {
    if (this.selectedHardwareStatus != 'blocked') {
    this.masterDataService.getAssetDetailsByBranchStatusExcel(this.selectBranch.id, this.selectedHardwareStatus).subscribe((resp: any) => {
      const blob = new Blob([resp]);
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      if (this.selectedHardwareStatus == 'assigned')
        link.download = "AssignedAssetsReport.xlsx";
      else if (this.selectedHardwareStatus == 'instock')
        link.download = "InStockAssetsReport.xlsx";
      else if (this.selectedHardwareStatus == 'all')
        link.download = "AllAssetsReport.xlsx";
      else
        link.download = "RetiredAssetsReport.xlsx";
      link.click();
    });
  }
}
}

